import { useWireValue } from '@forminator/react-wire'
import { remoteConfig as storeRemoteConfig } from '@store'
import useBillingViewModel from './BillingViewModel'

import { StripeElementsWrap } from '@components/shared/StripeElementsWrap'
import SettingsWrapper from '../SettingsWrapper'
import AddPaymentCardDialog from '@components/shared/Dialogs/AddPaymentCardDialog'
import BillingPlanDetails from './BillingPlanDetails'
import BillingCards from '@components/settings/Billing/BillingCards'
/* import BillingActivityHistory from '@components/settings/Billing/BillingActivityHistory' */

import 'flatpickr/dist/themes/dark.css'
import CircleSpinner from '@components/shared/CircleSpinner'
import ConfirmationModal from '@components/shared/ConfirmationModal'

const BillingContent = () => {
    
    /** @type {BillingViewModel} */
    const vm = useBillingViewModel()
    
    return (
        
        <SettingsWrapper title="Billing">
            
            <div className="flex flex-col gap-4">
                
                <BillingPlanDetails
                    credits={vm.credits}
                    planDetails={vm.planDetails} />
                
                {/* @todo moved this into a component for now, for cleanup,
                    but probably needs to be organized better once we enable Stripe */}
                {vm.remoteConfig.stripe.enabled && (
                    <BillingCards vm={vm} />
                )}
                
                {/* @todo disabled for now, since we don't have this setup yet */}
                {/* <BillingActivityHistory vm={vm} /> */}
            
            </div>
            
            <AddPaymentCardDialog />
            
            <ConfirmationModal
                showModal={vm.deleteCardModalOpen}
                showHideModal={vm.setDeleteCardModalOpen}
                title="Delete Card"
                onConfirm={vm.deleteSavedCard}
                message={<p>Are you sure you want to delete this card?</p>} />
        
        </SettingsWrapper>
        
    )
    
}

export const BillingComponent = () => {
    
    const remoteConfig = useWireValue(storeRemoteConfig)
    
    if (!Object.keys(remoteConfig?.stripe).length) return (
        <div className="w-full h-screen overflow-hidden flex flex-col justify-center items-center">
            <CircleSpinner className="absolute-centered" />
        </div>
    )
    
    return !remoteConfig.stripe.enabled
        ? <BillingContent />
        : (
            <StripeElementsWrap>
                <BillingContent />
            </StripeElementsWrap>
        )
    
}
